var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#c4af9a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 512,
    height: 768
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.3,407.5a223.68,223.68,0,0,0,24.8,5.8,353.75,353.75,0,0,0-57.7-18.9,196.47,196.47,0,0,0,24,10.2c2.9.9,5.9,1.9,8.9,2.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.8,416c-43-24.5-90.3-39.7-138-44.1,2.1,1.7,4.3,3.3,6.5,4.9a339.28,339.28,0,0,1,123.5,39.4c2.7,0,5.4,0,8-.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.8,360.6c56.7,4,111.6,22.9,159.2,53.4,2.3-.3,4.6-.8,6.8-1.2-3.1-2.1-6.3-4.1-9.5-6-48-29.6-102-47.2-156.2-51-6.4-.5-12.9-.7-19.4-.8,1.7,1.7,3.4,3.4,5.2,5,4.6.1,9.3.3,13.9.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.7,345.8c62.7,4.4,123.3,27.1,174,63.5,2.2-.6,4.4-1.2,6.5-1.9-7.7-5.6-15.6-11-23.8-16.1-48-29.6-102.1-47.3-156.4-51-13.7-1-27.5-1.1-41.3-.8,1.5,1.8,3,3.6,4.6,5.4,12.3-.2,24.4,0,36.4.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.7,330.9c67.5,4.7,132.5,30.7,185.5,72.1,2.2-.8,4.3-1.7,6.5-2.5a360,360,0,0,0-35-24.6c-48.1-29.6-102.2-47.3-156.5-51.1-20-1.4-40.3-1-60.3-.1l4.2,6c18.5-.8,37.2-1.1,55.6.2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.7,316.1c71.5,5,140.2,33.9,194.7,79.6,2.2-1,4.3-2.2,6.4-3.3a350.92,350.92,0,0,0-44-32c-48.1-29.7-102.3-47.3-156.7-51.1-25.7-1.8-51.8-.7-77.3.7,1.2,2.2,2.5,4.4,3.8,6.6,24.2-1.3,48.9-2.2,73.1-.5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.1,293.8c-29-2-58.6-.4-87.3,1.2l-5.5.3c1.1,2.4,2.3,4.8,3.5,7.2.8,0,1.6-.1,2.4-.1,28.4-1.6,57.8-3.2,86.4-1.2,74.8,5.2,146.5,36.6,202.2,86.2,2.2-1.3,4.3-2.6,6.4-4A359,359,0,0,0,316.9,345c-48.1-29.7-102.4-47.4-156.8-51.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.5,288.3c27.9-1.5,56.8-3.1,84.8-1.1,76.6,5.4,149.8,38.8,205.3,91.2,1.9-1.3,3.7-2.6,5.5-4a344.45,344.45,0,0,0-56.6-43.5c-47.2-29.2-100.4-46.6-153.8-50.4-28.5-2-57.6-.4-85.7,1.1l-23.1,1.2c.9,2.2,1.7,4.5,2.6,6.7l21-1.2"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181,273.2c78,5.6,152.3,40.7,207.4,95.5,1.6-1.3,3.1-2.6,4.6-4a342.8,342.8,0,0,0-60.8-48c-46.3-28.7-98.4-45.8-150.7-49.6-27.9-2-56.5-.5-84.1,1-13.2.7-26.5,1.4-39.8,1.7.6,2,1.3,4.1,2,6.1,12.8-.3,25.5-1,38.1-1.7,27.4-1.4,55.8-3,83.3-1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.7,259.2c78.9,5.8,153.9,42.3,208.4,99,1.3-1.2,2.6-2.5,3.9-3.8a335.91,335.91,0,0,0-64.1-51.8c-45.3-28.2-96.4-45.1-147.7-48.9-27.4-2-55.4-.6-82.5.8-18.4,1-37.1,1.9-55.7,1.8.4,1.8.9,3.7,1.4,5.5,18.3.1,36.6-.9,54.6-1.8,26.8-1.3,54.7-2.7,81.7-.8"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.4,288.5C303,260.8,253,244.2,202.7,240.4c-26.8-2-54.3-.6-80.8.7-23.4,1.2-47.2,2.4-70.8,1.2.3,1.6.6,3.3.9,4.9,23.4,1.1,47-.1,70.2-1.3,26.4-1.3,53.7-2.7,80.2-.7,79.4,6,154.8,43.6,208.5,101.8,1.1-1.2,2.1-2.4,3.1-3.6a324.81,324.81,0,0,0-66.6-54.9"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M423.4,331.7a323.67,323.67,0,0,0-68.3-57.4c-43.4-27.2-92.4-43.5-141.7-47.3-26.3-2-53.2-.7-79.2.6-28.1,1.4-56.8,2.8-85-.1.1,1.4.3,2.9.4,4.3,28.2,2.7,56.8,1.4,84.7,0,25.9-1.3,52.7-2.6,78.7-.6,79.5,6.1,155,44.6,207.7,103.8,1-1.1,1.8-2.2,2.7-3.3"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.6,217.7c25.4-1.2,51.6-2.5,77.1-.5,79.3,6.2,154.4,45.2,206.2,105,.7-1,1.3-2,2-3.1a317,317,0,0,0-69.2-59c-42.5-26.7-90.4-42.8-138.6-46.5-25.7-2-52.1-.8-77.6.5-32.4,1.5-65.8,3.1-98-2.1,0,1.2.1,2.4.1,3.6,32.3,5.2,65.6,3.7,98,2.1"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.9,203.6c24.9-1.1,50.6-2.3,75.6-.3,78.6,6.3,153,45.5,203.7,105.3.5-.9,1-1.9,1.5-2.8-51.2-59.9-125.9-99.2-205-105.5-25.2-2-51-.8-76,.3-36.5,1.7-74.1,3.4-110-5-.1,1-.1,2-.2,3,36.2,8.4,73.9,6.7,110.4,5"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.1,189.5c24.4-1.1,49.6-2.2,74.1-.2,77.5,6.3,150.7,45.2,200.3,104.6.3-.8.7-1.5,1-2.3-50-59.3-123.5-98.2-201.2-104.5-24.6-2-49.9-.9-74.4.2-37.1,1.6-75.4,3.3-111.6-6-3-.8-5.9-1.6-8.9-2.5-.1.8-.2,1.5-.3,2.3,2.8.9,5.7,1.7,8.6,2.5,36.7,9.2,75.2,7.5,112.4,5.9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.3,175.4c23.9-1,48.5-2.1,72.5-.1,75.9,6.3,147.5,44.5,196,102.7l.6-1.8C403.7,218.1,332,179.9,256,173.6c-24.1-2-48.8-.9-72.7.1-36.3,1.5-73.8,3.2-109.3-6a188.28,188.28,0,0,1-20.1-6.4c-.1.5-.3,1.1-.4,1.6a203.36,203.36,0,0,0,20.1,6.3c35.7,9.3,73.3,7.7,109.7,6.2"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.6,161.2c23.4-1,47.5-1.9,71,0,73.7,6.3,143.2,43.3,190.6,99.5l.3-1.2a287.45,287.45,0,0,0-64.3-55.9c-38.7-24.7-82.4-39.7-126.5-43.4-23.6-2-47.7-1-71.1-.1-35.5,1.5-72.3,3-107.1-6.1a191,191,0,0,1-29.8-10.4c-.1.3-.2.6-.3,1A203.17,203.17,0,0,0,88.3,155c34.9,9.2,71.7,7.7,107.3,6.2"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.8,147.1c22.8-.9,46.5-1.8,69.5.2,70.8,6.1,137.6,41.3,183.9,94.7a.6.6,0,0,1,.1-.4,282.67,282.67,0,0,0-60.4-52.1c-37.7-24.2-80.4-38.9-123.5-42.6-23-2-46.6-1.1-69.5-.2-34.8,1.4-70.7,2.8-104.8-6.2a187.35,187.35,0,0,1-37.8-14.3c-.1.1-.1.2-.2.3a202.74,202.74,0,0,0,37.8,14.3c34.1,9.1,70.1,7.7,104.9,6.3"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218,136.6c22.4-.9,45.6-1.8,68.2.2,67.7,5.9,131.8,38.8,176.9,89.1,0-.4.1-.9.1-1.3a279.31,279.31,0,0,0-55.6-46.9c-37.1-23.7-79.1-38.2-121.4-41.9-22.6-2-45.8-1.1-68.3-.2-34.1,1.3-69.4,2.7-102.8-6.1a188.51,188.51,0,0,1-43.2-17.3c-.2.3-.3.6-.5.9a192.15,192.15,0,0,0,43.4,17.4c33.7,8.9,69,7.5,103.2,6.1"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.1,20c3.7-.1,7.5-.3,11.3-.4-4.9-2.2-9.9-4.4-15-6.2-26,1-52.7,1.7-77.9-4.9a127.07,127.07,0,0,1-18.3-6.2c-4.2.5-8.3,1.1-12.4,1.9a155.36,155.36,0,0,0,29,10.8c27.3,7.1,55.8,6,83.3,5"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.1,126.2c22-.9,44.7-1.7,66.8.2,64.1,5.6,124.9,35.9,168.9,82.4v-.2c0-.8-.1-1.5-.1-2.3-44.2-46-104.7-76-168.7-81.5-22.2-1.9-45-1-67.1-.2-33.5,1.3-68,2.7-100.8-5.9A186,186,0,0,1,79.5,98.8c-.3.5-.6.9-.9,1.4a189.25,189.25,0,0,0,48,20.1c33.3,8.5,68,7.2,101.5,5.9"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.3,115.7c21.6-.8,43.9-1.7,65.5.2,59.8,5.2,116.6,32.3,159.1,74.2-.1-1.2-.2-2.3-.3-3.5-42.7-41.2-99.2-67.9-158.6-73-21.8-1.9-44.2-1-65.8-.2-32.8,1.3-66.7,2.6-98.8-5.8A181,181,0,0,1,88.6,85.5a21.41,21.41,0,0,0-1.3,1.9,186,186,0,0,0,51.5,22.4c32.5,8.5,66.5,7.2,99.5,5.9"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.5,105.2c21.1-.8,43-1.7,64.2.2,54.8,4.8,107,28.3,147.6,64.9-.3-1.6-.6-3.2-.9-4.7-40.6-35.5-92.3-58.4-146.4-63.1-21.4-1.9-43.4-1-64.6-.2-32.1,1.3-65.4,2.6-96.8-5.7A179.71,179.71,0,0,1,98.7,73l-1.9,2.2a182.8,182.8,0,0,0,54.1,24.2c31.8,8.4,65.2,7.1,97.6,5.8"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.6,94.7c20.7-.8,42.1-1.6,62.9.2,48.9,4.2,95.7,23.8,133.6,54.3-.6-2-1.3-4.1-1.9-6.1C415.4,114,369.6,95.4,321.8,91.3c-21-1.8-42.6-1-63.4-.2-31.5,1.2-64,2.5-94.8-5.6a175.59,175.59,0,0,1-53.9-24.6c-.9.9-1.7,1.7-2.5,2.6a177.55,177.55,0,0,0,55.6,25.4c31.3,8.3,64.1,7.1,95.8,5.8"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.8,84.2c20.3-.8,41.3-1.6,61.6.2,42,3.6,82.5,18.9,116.9,42.8-1-2.5-2.2-4.9-3.3-7.3-33.7-22.1-72.8-36.2-113.2-39.7-20.6-1.8-41.7-1-62.2-.2-30.8,1.2-62.7,2.4-92.8-5.4A171,171,0,0,1,122,49.8c-1.1.9-2.2,1.9-3.3,2.9a176.63,176.63,0,0,0,56,26c30.8,8,63,6.8,94.1,5.5"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279,73.8c19.9-.8,40.4-1.6,60.3.1A235.61,235.61,0,0,1,436,104.6q-2.4-4.2-5.1-8.4a238.59,238.59,0,0,0-91.1-27.1c-20.2-1.8-40.9-.9-60.9-.2-30.2,1.2-61.4,2.4-90.8-5.3a166.21,166.21,0,0,1-52.5-24.2l-4.2,3a172.84,172.84,0,0,0,55.5,25.9c30,7.9,61.5,6.7,92.1,5.5"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.1,63.3c19.4-.8,39.5-1.5,59,.1a228.29,228.29,0,0,1,73.1,19.1c-2.4-3.1-4.8-6.1-7.3-9A231.42,231.42,0,0,0,348.6,58c-19.8-1.7-40.1-.9-59.7-.2-29.5,1.2-60,2.3-88.8-5.2A163.45,163.45,0,0,1,150,29.8c-1.7,1-3.4,2.1-5.1,3.2a169.2,169.2,0,0,0,53.8,24.9c29.6,7.8,60.5,6.6,90.4,5.4"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M299.3,52.8c19-.7,38.7-1.5,57.7.1a222.67,222.67,0,0,1,46.5,9.2c-3.1-3.1-6.4-6.2-9.7-9.1a222.1,222.1,0,0,0-36.3-6.2c-19.4-1.7-39.3-.9-58.5-.2-28.9,1.1-58.7,2.3-86.8-5.1A159.3,159.3,0,0,1,166,21.1c-2.1,1-4.2,2.1-6.2,3.2a164,164,0,0,0,50.9,23.1c29,7.7,59.3,6.6,88.6,5.4"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.5,42.3c18.6-.7,37.8-1.5,56.4.1,6.1.6,12.1,1.4,18.1,2.4-3.8-3-7.6-5.8-11.6-8.5l-5.9-.6c-19-1.7-38.5-.9-57.3-.2-28.2,1.1-57.4,2.2-84.8-5a154.65,154.65,0,0,1-40.4-17c-2.7,1-5.3,2-7.9,3.1a165.29,165.29,0,0,0,46.5,20.5c28.5,7.5,58.2,6.3,86.9,5.2"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.6,31.8c14.8-.6,30.1-1.2,45-.5-4.5-2.8-9.1-5.3-13.8-7.7-10.6,0-21.2.4-31.5.8-27.5,1.1-56,2.2-82.8-4.8A148.65,148.65,0,0,1,204.6,7.2c-3.4.9-6.8,1.8-10.2,2.9a157.46,157.46,0,0,0,40.2,16.7c27.9,7.3,56.9,6.1,85,5"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.4,8.8A208.21,208.21,0,0,0,256.1.7c-1.1,0-2.2.1-3.3.1q4.05,1.35,8.1,2.4c17.2,4.5,34.9,5.7,52.5,5.6"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.3 607.6 27.9 661.3 10.5 607.6 7.7 607.6 0.5 665.7 1.6 665.7 7.2 619.8 22.4 665.7 27.6 665.7 42.6 619.2 48.4 665.7 55.3 665.7 48 607.6 45.3 607.6"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.2,665.7h7.1L89.4,607.1l-.9.4L63.7,665.7h1l7.9-18.3H96.9ZM72.8,646.6l13-30.1,10.6,30.1Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.6,638.2h10.7l16.3,27.5h7.7l-16.6-28c4.6-1,7.8-3,9.7-6.1a19.07,19.07,0,0,0,2.8-10.4c0-9.1-6.8-13.7-20.5-13.7-4.9,0-10.6.2-17,.7v57.5h6.9Zm0-29.2a89.46,89.46,0,0,1,10.1-.6c4.6,0,8.1,1.1,10.4,3.4s3.5,5.5,3.5,9.7c0,10.3-3.9,15.6-11.7,16H124.6Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "202.5 664.9 174.5 664.9 174.5 634.2 198.8 634.2 198.8 633.3 174.5 633.3 174.5 608.4 200.7 608.4 200.7 607.6 167.7 607.6 167.7 665.7 202.5 665.7 202.5 664.9"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.4,633.2h9.3a56.78,56.78,0,0,1-12.3,21.1,35.19,35.19,0,0,1-10.2,7.7,25.44,25.44,0,0,1-11.7,3,16,16,0,0,1-9.7-2.9,17.29,17.29,0,0,1-5.9-7.8l41.2-32.4-.6-.5-13.8,10.9q-.45-12.9-15-12.9c-5.3,0-10.1,2.3-14.2,7a24.83,24.83,0,0,0-6.3,17.2,24.48,24.48,0,0,0,1.7,9.3,17.82,17.82,0,0,0,4.2,6.4,20.2,20.2,0,0,0,5.9,3.9,29.06,29.06,0,0,0,12.6,2.7,35.82,35.82,0,0,0,14-2.9,42,42,0,0,0,11.9-7.7,57.44,57.44,0,0,0,14.9-21.9H302v-.8H281.5v.6ZM239,646.8l-.2-3.7a38.93,38.93,0,0,1,2.9-15,15.17,15.17,0,0,1,4.4-5.8,11.14,11.14,0,0,1,7.1-2.2,6.17,6.17,0,0,1,6,3.9c1.2,2.6,1.8,7.1,1.9,13.4l-20.6,16.2a32.47,32.47,0,0,1-1.5-6.8"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "367.3 664.9 342.6 664.9 342.6 607.6 335.7 607.6 335.7 665.7 367.3 665.7 367.3 664.9"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.6,665.1a37,37,0,0,0,8.9,1A16.9,16.9,0,0,0,409,660c3.4-4.1,5.2-10.5,5.2-19.1V607.7h-1.1v33.1c0,8.5-1.6,14.7-4.8,18.7a15.67,15.67,0,0,1-12.8,5.9,18.25,18.25,0,0,1-6.1-.9,12.46,12.46,0,0,1-4.9-3.4c-3-3.4-4.6-10.1-4.6-20.2V607.8H373V641c0,10.4,2.2,17.3,6.6,20.8a23.44,23.44,0,0,0,7,3.3"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M465.7,663.6c-1.3.3-3.2.7-5.6,1.1a42.55,42.55,0,0,1-6.7.6,35.27,35.27,0,0,1-5-.3,21.52,21.52,0,0,1-5.6-1.9,17.24,17.24,0,0,1-5.9-4.4,24.92,24.92,0,0,1-4.4-8.4,37.94,37.94,0,0,1-1.9-12.4,52.36,52.36,0,0,1,1.1-11.4c1.2-5.5,3.3-9.6,6.3-12.5a20.21,20.21,0,0,1,14.7-5.7,33.87,33.87,0,0,1,12.5,2.2l.2-.8-1.5-.6a23.42,23.42,0,0,0-4.7-1.1,34.93,34.93,0,0,0-6.5-.5c-7.8,0-14.4,2-19.9,6.1a21.6,21.6,0,0,0-6.7,9.2,35.55,35.55,0,0,0-2.4,13.4,39.44,39.44,0,0,0,1.7,12.7,23.65,23.65,0,0,0,4.3,8.4c5,5.9,12.7,8.8,23,8.8a45.59,45.59,0,0,0,15.2-2.2l-.2-.8Z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "483.5 664.9 483.5 634.2 507.8 634.2 507.8 633.3 483.5 633.3 483.5 608.4 509.7 608.4 509.7 607.6 476.6 607.6 476.6 665.7 511.5 665.7 511.5 664.9 483.5 664.9"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "104.7 727.8 89.1 727.8 89.1 691.6 84.8 691.6 84.8 728.3 104.7 728.3 104.7 727.8"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.3,712.6v-21h-.7v20.9c0,5.4-1,9.3-3,11.8a9.79,9.79,0,0,1-8.1,3.7,11.42,11.42,0,0,1-3.9-.6,7.75,7.75,0,0,1-3.1-2.2c-1.9-2.1-2.9-6.4-2.9-12.8V691.5h-4.4v21c0,6.6,1.4,10.9,4.2,13.1a11.4,11.4,0,0,0,4.4,2.2,22.31,22.31,0,0,0,5.6.6,10.58,10.58,0,0,0,8.5-3.9c2.3-2.4,3.4-6.4,3.4-11.9"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165 728.3 153.1 707.8 161.2 691.6 160.6 691.6 152.7 707.2 143.7 691.6 139.3 691.6 149.7 709.6 140.2 728.3 140.9 728.3 150 710.1 160.6 728.3 165 728.3"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.7,691.6v21c0,6.6,1.4,10.9,4.2,13.1a11.4,11.4,0,0,0,4.4,2.2,22.31,22.31,0,0,0,5.6.6,10.58,10.58,0,0,0,8.5-3.9c2.2-2.6,3.2-6.6,3.2-12.1v-21H194v20.9c0,5.4-1,9.3-3,11.8a9.79,9.79,0,0,1-8.1,3.7,11.42,11.42,0,0,1-3.9-.6,7.75,7.75,0,0,1-3.1-2.2c-1.9-2.1-2.9-6.4-2.9-12.8V691.4h-4.3Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217,710.7c2.9-.6,5-1.9,6.1-3.8a12.1,12.1,0,0,0,1.8-6.6c0-5.8-4.3-8.7-13-8.7-3.1,0-6.7.1-10.8.4v36.3h4.4V711h6.8l10.3,17.4h4.9Zm-11.5-.2V692.6c2.2-.2,4.4-.4,6.4-.4q4.35,0,6.6,2.1a8,8,0,0,1,2.2,6.1c0,6.5-2.5,9.9-7.4,10.1Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.1,715.3l-10-23.7h-4.5l10.5,25.5v11.3h4.4V716l9.4-19a6.6,6.6,0,0,0,.6-2.7,3.54,3.54,0,0,0-1-2.6l-.4.3a3.11,3.11,0,0,1,.8,2.2,6.26,6.26,0,0,1-.6,2.7Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301,694.2a3.39,3.39,0,0,0-1-2.6l-.4.3a3.11,3.11,0,0,1,.8,2.2,6.26,6.26,0,0,1-.6,2.7l-11.2,25.8-11-31.1h-4.5l13.2,37,.6-.3,13.4-31.5a3.67,3.67,0,0,0,.7-2.5"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "315.6 692.1 315.6 691.6 306.3 691.6 306.3 692.1 308.7 692.1 308.7 727.8 306.3 727.8 306.3 728.3 315.6 728.3 315.6 727.8 313.1 727.8 313.1 692.1 315.6 692.1"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "327.3 691.6 323 691.6 323 728.3 342.9 728.3 342.9 727.8 327.3 727.8 327.3 691.6"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "368.1 727.8 352.5 727.8 352.5 691.6 348.2 691.6 348.2 728.3 368.1 728.3 368.1 727.8"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.9,691.6l-15.7,36.7h.6l5-11.5h15.3l4.1,11.5h4.5l-13.2-37Zm-9.8,24.7,8.2-19,6.7,19Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M423.5,710.1a36.07,36.07,0,0,0-3.9-2.2c-1.4-.6-2.9-1.2-4.3-1.7a35.17,35.17,0,0,1-3.9-1.7c-2.7-1.4-4-3.4-4-5.9a5.76,5.76,0,0,1,2.4-4.9,10.78,10.78,0,0,1,6.6-1.8,25.71,25.71,0,0,1,9,1.8l.2-.5a33.12,33.12,0,0,0-10.5-1.8c-3.4,0-6,.8-7.7,2.4a8.78,8.78,0,0,0,1.4,13.6,36.07,36.07,0,0,0,3.9,2.2c1.4.7,2.9,1.3,4.3,1.9a35.36,35.36,0,0,1,3.9,1.9,7.32,7.32,0,0,1,4,6.6,6.43,6.43,0,0,1-3,5.8,13,13,0,0,1-7.3,2,17.74,17.74,0,0,1-5.6-.9,15.73,15.73,0,0,1-4.5-2.2l-.3.4a18.8,18.8,0,0,0,11,3.2,22.54,22.54,0,0,0,6.1-.8,8.94,8.94,0,0,0,4.4-3.1,8.74,8.74,0,0,0,1.8-5.6,12,12,0,0,0-1.1-5.4,9.25,9.25,0,0,0-2.9-3.3"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.4,554.5l1.4.3,9.7-5.9,7.2-4.3c-.4-.2-.7-.3-1.1-.5-.1,0-.1-.1-.2-.1-.4-.2-.7-.3-1.1-.5l-5.7,3.4-11.8,7.2,1.4.3a.31.31,0,0,0,.2.1"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.1,552.9a15,15,0,0,1,2.2-.2l28.5-18.5c-.5-.1-1-.1-1.6-.2h-.4a10,10,0,0,1-1.6-.2l-13.6,8.9-16.3,10.6,2.3-.3a4.33,4.33,0,0,1,.5-.1"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175,563.1c.5,0,1.1.1,1.6.1l10-6.5h0l11.2-7.4c-2.1,1-4.3,2.1-6.6,3.1-.8.4-1.7.8-2.5,1.2-1.5.7-3.1,1.4-4.7,2.1-.2.1-.4.1-.5.2L172.6,563c.5,0,1.1.1,1.6.1h.8"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.3,551.6a9.15,9.15,0,0,1,1.7.1l19.7-12.4h0l1.2-.7c-.4-.1-.8-.3-1.2-.4-.1,0-.2-.1-.3-.1-.4-.1-.8-.3-1.2-.4l-22,13.9a9.15,9.15,0,0,1,1.7.1.76.76,0,0,1,.4-.1"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.2,557.5a4.87,4.87,0,0,0,1.1-.4c1-.3,2.1-.7,3.3-1l3-2h.1L244.8,539h0l8.4-5.5a12.1,12.1,0,0,0-1.9.1h-.6a12.1,12.1,0,0,0-1.9.1l-5,3.3-23.6,15.5h0l-9.5,6.2a11.76,11.76,0,0,0,2-.7,13.14,13.14,0,0,0,1.5-.5"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.5,548.3l19.2-12.8-2.7.6-1.1.3a28.64,28.64,0,0,0-2.8.7l-14.3,9.5h0L191.9,561h0l-3,2c.7-.1,1.4-.1,2-.2h.7l2.2-.3,21.7-14.2Z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.4,551.7c.6,0,1.3-.1,1.9-.1l3-2,21.3-13.7-1.3-.3a.76.76,0,0,1-.4-.1,7.84,7.84,0,0,0-1.4-.2l-19.1,12.3-6.4,4.1c.7,0,1.3-.1,2-.1a.6.6,0,0,0,.4.1"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.5,556.1h-.1a4.87,4.87,0,0,1-1.1-.4.1.1,0,0,1-.1-.1l-9.4,5.2a7.72,7.72,0,0,0,1.5.2h.2a8.75,8.75,0,0,0,1.6.2l8.8-4.8a4.88,4.88,0,0,1-1.4-.3"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.3,553.5h-.1c-.4-.2-.7-.3-1.1-.5l-11.5,6.5,1.5.3h.1l1.5.3,10.7-6a4.07,4.07,0,0,0-1.1-.6"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.4,560.3l-2,1.1c1.1-.2,2.2-.3,3.2-.5h.2c.2,0,.4-.1.6-.1a.37.37,0,0,1-.3-.1H349a7.49,7.49,0,0,0-1.6-.4"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.6,562.1h.1a11,11,0,0,1,1.8.2l7.4-4-1.5-.3h-.1l-1.5-.3-7.9,4.3a10.28,10.28,0,0,1,1.7.1"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.4,556.4l1.4.3,5.2-3.1,9.6-5.6c-.4-.2-.7-.3-1.1-.5a.1.1,0,0,1-.1-.1c-.4-.2-.7-.3-1.1-.5l-8.4,4.9-7.2,4.3,1.4.3c.2-.1.2,0,.3,0"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.2,552.6l1.5.3,14.2-8.8,4.3-2.6c-.4-.1-.8-.3-1.2-.4-.1,0-.1-.1-.2-.1-.4-.1-.8-.3-1.2-.4l-2.7,1.6-16.5,10.3a7.72,7.72,0,0,0,1.5.2c.2-.1.2-.1.3-.1"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.2,551.1c-.4-.2-.7-.3-1.1-.5a.1.1,0,0,1-.1-.1c-.4-.2-.7-.3-1.1-.5l-10.8,6.2-2.8,1.6,1.5.3h.2l1.5.3.8-.4Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.2,561.4l1.4.3,3-1.9-2.2.3c-.3,0-.7.1-1,.1a18,18,0,0,1-2.2.2l-1,.6,1.4.3c.2,0,.4.1.6.1"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.1,562.4a22.86,22.86,0,0,0,2.5-.2l4.9-2.6-1.6-.3h-.1l-1.6-.3-6.3,3.3H336a.1.1,0,0,0,.1.1"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173,526.9l-4,2.6c.9-.1,1.8-.1,2.7-.2a2.77,2.77,0,0,0,.9-.1l2.9-.3,28.3-18.6h.1l25.2-16.7c-1.2.2-2.3.5-3.5.8l-1.4.3-3.7.9L201.7,508h0L173,526.9Z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.1,521.2l14.7-9.7c-2.8,1.4-5.7,2.7-8.6,4.1l-3.3,1.5c-2,.9-4.1,1.8-6.2,2.7-.2.1-.5.2-.7.3l-14.2,9.3a14.77,14.77,0,0,0,2.1.1h.8c.7,0,1.4.1,2.2.1l13.2-8.4Z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.2,522.3c.5-.2.9-.3,1.4-.5,1.4-.4,2.8-.9,4.3-1.3l3.9-2.6h.1l30.2-19.8h0l11-7.2c-.8,0-1.7.1-2.5.1h-.8a20.9,20.9,0,0,0-2.5.1l-6.6,4.3-30.9,20.3h0l-12.4,8.1c.9-.3,1.8-.5,2.7-.9a8.3,8.3,0,0,0,2.1-.6"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.9,514.6c.8,0,1.5.1,2.2.1l25.8-16.3h0l1.5-.9c-.5-.2-1.1-.3-1.6-.5-.1,0-.2-.1-.4-.1-.5-.2-1.1-.3-1.6-.5L265,514.6a17.7,17.7,0,0,1,2.3.1,1.49,1.49,0,0,1,.6-.1"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.8,526l-2.7,1.4c1.4-.2,2.8-.4,4.2-.7h.2a2.2,2.2,0,0,1,.8-.1.76.76,0,0,1-.4-.1h-.1a6.53,6.53,0,0,0-2-.5"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.9,516.3l2.8-.3L271,491.8c-.7-.1-1.4-.1-2-.2a1.27,1.27,0,0,1-.6-.1,15,15,0,0,0-2-.2l-17.8,11.6-21.4,13.9c1-.1,2-.3,3-.4.2,0,.5-.1.7-.1"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.9,514.7c.8,0,1.7-.1,2.5-.1l4-2.6,27.9-17.9c-.6-.1-1.1-.3-1.7-.4a.9.9,0,0,1-.5-.1l-1.9-.3-25,16.1-8.4,5.4c.9,0,1.7-.1,2.6-.1h.5"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.9,525.1a14.16,14.16,0,0,1,2,.4l14-7.8a10.09,10.09,0,0,1-1.5-.7.1.1,0,0,1-.1-.1,6.11,6.11,0,0,1-1.4-.7l-15.1,8.5a14.16,14.16,0,0,1,2,.4h.1"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.6,528.3a19.53,19.53,0,0,0,2.3.2l9.6-5.2a11.8,11.8,0,0,1-2-.4h-.1c-.6-.1-1.3-.3-1.9-.4l-10.3,5.6c.8.1,1.5.1,2.3.2h.1"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.4,527h.2l2.1.3,11.4-6.2c-.5-.2-1-.4-1.6-.6-.1,0-.1,0-.2-.1-.5-.2-.9-.3-1.4-.5-.1,0-.1-.1-.2-.1l-12.4,6.8c.8.2,1.5.3,2.1.4"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.4,513.2c-.1,0-.1-.1-.2-.1-.5-.2-.9-.5-1.4-.7l-14.1,8.1-3.7,2.1a12.86,12.86,0,0,1,1.9.4h.2c.6.1,1.3.3,1.9.4l1-.6,15.7-9c-.4-.2-.8-.4-1.3-.6"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.1,515.9l1.9.3,18.6-11.6,5.7-3.5-1.5-.6c-.1,0-.2-.1-.3-.1l-1.5-.6-3.5,2.1-21.6,13.4c.7.1,1.3.2,1.9.3.1.3.2.3.3.3"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.2,518.4c.6.1,1.2.3,1.8.4l12.7-7.7,9.4-5.6c-.5-.2-.9-.4-1.4-.6a.35.35,0,0,1-.2-.1c-.5-.2-.9-.4-1.4-.6l-7.4,4.5-15.5,9.4c.6.1,1.2.3,1.8.4,0-.2.1-.2.2-.1"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.2,509.7a9.14,9.14,0,0,1-1.4-.7c-.1,0-.1-.1-.2-.1a9.14,9.14,0,0,1-1.4-.7l-11,6.5-9.4,5.6c.6.1,1.2.3,1.9.4h.2c.6.1,1.2.3,1.9.4l6.8-4.1Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.5,524.7h-.1l-2.1-.3-8.3,4.4h3c1.1,0,2.1-.2,3.2-.2l6.5-3.4a9.83,9.83,0,0,0-2.2-.5"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133,525.8c-1.1.1-2,.2-2.8.3l-1.3.8,1.8.3c.3.1.6.1.8.2l1.8.3,3.9-2.5c-1,.1-2,.3-2.9.4-.5.1-.9.1-1.3.2"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.4,465.9c-.5-.2-1-.5-1.5-.7-.1,0-.1-.1-.2-.1-.5-.2-1-.5-1.5-.7l-12.1,7.1-10.3,6.2c.7.1,1.3.3,2,.4a.37.37,0,0,1,.3.1c.7.1,1.4.3,2,.4l7.5-4.5Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.1,482.8c.7.1,1.5.3,2.2.4l15.4-8.6c-.5-.2-1.1-.5-1.6-.7a.31.31,0,0,1-.2-.1c-.5-.2-1.1-.5-1.6-.7l-16.6,9.3c.7.1,1.4.3,2.2.4h.2"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.7,480.4h-.2a16,16,0,0,1-2.1-.5L356.1,486a22.86,22.86,0,0,0,2.5.2h.2a22.86,22.86,0,0,0,2.5.2l10.5-5.7a8.18,8.18,0,0,1-2.1-.3"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.3,480.5c.7.1,1.4.3,2.1.4l1.1-.6,17.2-9.9c-.5-.2-1-.5-1.5-.7-.1,0-.1-.1-.2-.1-.5-.2-1-.5-1.5-.7L325,477.8l-4,2.4c.7.1,1.4.3,2.1.4a.31.31,0,0,1,.2-.1"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.9,484.8a18.46,18.46,0,0,1,2.3.4l12.5-6.8a12.2,12.2,0,0,1-1.7-.7c-.1,0-.1,0-.2-.1l-1.5-.6c-.1,0-.1-.1-.2-.1l-13.6,7.5a14.35,14.35,0,0,1,2.2.4h.2"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286,448.2a15.52,15.52,0,0,1-2.1-.4l-27.4,17.6-9.2,6a26.2,26.2,0,0,1,2.8-.1h.6c.9,0,1.8-.1,2.7-.1l4.4-2.8,30.5-19.6a13.32,13.32,0,0,1-1.9-.5.76.76,0,0,1-.4-.1"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.9,487.2c1.1-.1,2.1-.2,3.2-.4l31-20.3h.1l27.6-18.3-3.9.9c-.5.1-1,.3-1.5.4-1.4.3-2.7.6-4.1,1l-20.5,13.6h0l-31.4,20.7h0l-4.3,2.8c1-.1,2-.1,2.9-.2.3-.1.6-.1.9-.2"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.4,479.7a8.8,8.8,0,0,1,1.5-.5c1.5-.5,3.1-.9,4.7-1.4l4.3-2.8h.1l33.1-21.7h0l12-7.9c-.9,0-1.8.1-2.7.1h-.9a24.37,24.37,0,0,0-2.7.1l-7.2,4.7-33.9,22.2h0l-13.6,8.9c1-.3,2-.6,2.9-.9s1.6-.5,2.4-.8"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141,487.8c.8,0,1.6.1,2.4.1l14.3-9.4h.1l16.1-10.6c-3.1,1.5-6.2,3-9.4,4.5-1.2.6-2.4,1.1-3.6,1.7-2.2,1-4.4,2-6.8,3a6.89,6.89,0,0,1-.8.3l-15.6,10.2a19.27,19.27,0,0,0,2.4.1,2.77,2.77,0,0,1,.9.1"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.6,484.4a2.49,2.49,0,0,1,.8-.1c-.1,0-.3-.1-.4-.1h-.1c-.7-.2-1.5-.3-2.2-.5l-3,1.5c1.5-.2,3.1-.5,4.6-.8.1.1.2,0,.3,0"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.9,446a16.35,16.35,0,0,0-2.2-.2l-19.6,12.7-23.5,15.2c1.1-.2,2.2-.3,3.3-.4.3,0,.6-.1.9-.1,1-.1,2.1-.2,3.1-.4l40.9-26.5a16.35,16.35,0,0,0-2.2-.2,2,2,0,0,0-.7-.1"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.9,475.3a.37.37,0,0,1,.3.1c.7.1,1.3.3,2,.4l13.9-8.5,10.3-6.1c-.5-.2-1-.5-1.5-.7-.1,0-.2-.1-.3-.1-.5-.2-1-.5-1.6-.7l-8.1,4.9-17,10.3c.6.1,1.3.3,2,.4"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.6,455.8c-.5-.2-1.1-.4-1.7-.6l-3.8,2.3-23.6,14.7,2.1.3a.76.76,0,0,1,.4.1,15.52,15.52,0,0,1,2.1.4l20.3-12.7,6.2-3.8c-.5-.2-1.1-.4-1.7-.6a.37.37,0,0,1-.3-.1"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M299.6,451.8a12.09,12.09,0,0,0-1.8-.5l-31.5,19.9a20.08,20.08,0,0,1,2.5.1h.5c.8,0,1.7.1,2.5.1l28.3-17.8h0l1.7-1L300,452c-.2-.2-.3-.2-.4-.2"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.4,486.7c1.2,0,2.4-.2,3.5-.3l7.1-3.7c-.8-.1-1.5-.3-2.3-.4h-.1a15.72,15.72,0,0,1-2.3-.4l-9.1,4.8h3.2"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.9,485.3c.7.1,1.3.3,2,.4l4.3-2.8c-1.1.1-2.2.3-3.2.4-.5.1-1,.1-1.4.2-1.2.1-2.2.3-3.1.4l-1.4.9a17.66,17.66,0,0,1,2,.4,2.81,2.81,0,0,1,.8.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGold);
export default __webpack_public_path__ + "static/media/logo_gold.b251f02385d2aebb557378f2c243f11e.svg";
export { ForwardRef as ReactComponent };